import { ENABLE_GITHUB } from '@core/constant/featureFlags';
import { throwOnErr } from '@core/util/result';
import { agentHarnessServiceClient } from '@service-agent-harness/client';
import { queryOptions, useQuery } from '@tanstack/solid-query';
import { agentRepositoryKeys } from './keys';

/**
 * The branches on one GitHub repository the signed-in user can start a
 * coding session from. The same listing the picker offers, authorized the
 * same way as an explicit `repoUrl` on create-session.
 *
 * Enabled only while a repository is selected: listing costs a GitHub call
 * per repository, and chat agents never ask.
 */
export function useAgentRepositoryBranchesQuery(
  repoUrl: () => string | undefined
) {
  return useQuery(() => agentRepositoryBranchesQueryOptions(repoUrl() ?? ''));
}

function agentRepositoryBranchesQueryOptions(url: string) {
  return queryOptions({
    queryKey: agentRepositoryKeys.branches(url).queryKey,
    queryFn: () =>
      throwOnErr(() => agentHarnessServiceClient.listRepositoryBranches(url)),
    enabled: ENABLE_GITHUB && !!url,
    staleTime: 2 * 60 * 1000,
  });
}
